import AtmSiteLogo from './AtmSiteLogo';
import RetailTherapyLogo from './RetailTherapyLogo';
import SiteLogo from './SiteLogo';
import XSiteLogo from './XSiteLogo';
import SiteSquiggle from './SiteSquiggle';

export const ATM_SITE_LOGO = AtmSiteLogo;
export const RETAIL_THERAPY_LOGO = RetailTherapyLogo;
export const SITE_LOGO = SiteLogo;
export const X_SITE_LOGO = XSiteLogo;
export const SITE_SQUIGGLE = SiteSquiggle;

export default {
  ATM_SITE_LOGO,
  RETAIL_THERAPY_LOGO,
  SITE_LOGO,
  X_SITE_LOGO,
  SITE_SQUIGGLE
};
